import { versionedHttpCollection } from "us.helper/http/collection";
import ServiceConfig from "service.config.js";

export default {
  documentCategories: {
    get: <P extends {}>(params: P): Promise<{}> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "documentservice",
            "documents/documentCategories",
            params,
            "v1",
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  entityInfo: {
    get: <P extends { assignTo: number; entityType: string }>(
      params: P,
    ): Promise<{}> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { status, data } = await versionedHttpCollection.get(
            "entityservice",
            "entity/Info",
            { assignTo: params?.assignTo, entityType: params?.entityType },
            "v1",
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  caseAssignment: {
    save: <
      D extends Array<any>,
      P extends {
        entityType: string;
        entityId: string;
        documentType: string;
        storageType: string;
        addToHistory: boolean;
        isMappedDoc: boolean;
        isSendNotification: boolean;
      },
    >(
      fileList: D,
      params: P,
    ): Promise<{}> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("entityId", params.entityId);
          formData.append("entityType", params.entityType);
          formData.append("documentType", params.documentType);
          formData.append("StorageType", params.storageType);
          formData.append("noteText", "");
          formData.append("addToHistory", params.addToHistory.toString());
          formData.append("isMappedDoc", params.isMappedDoc.toString());
          formData.append(
            "isSendNotification",
            params.isSendNotification.toString(),
          );

          fileList.map((file: any, index: number) => {
            formData.append(`file${index}`, file, file.name);
          });
          const { data, status } = await versionedHttpCollection.uploadFile(
            "documentservice",
            "document",
            formData,
            ServiceConfig()[`documentservice`]["document"],
          );

          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  assignedDocument: {
    delete: <P extends {}>(params: P): Promise<{}> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.patch(
            "documentservice",
            "mappedDocumentList",
            params,
            ServiceConfig()[`documentservice`]["document"],
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
